import React from "react";
import { TextInput, StepHeader } from "../activity-components/FormComponents";
import { StepProps, ActivityFormProps } from "../types";

type Props = StepProps &
  Pick<ActivityFormProps, "descriptionOfTab3"> & {
    onChange: (
      k: keyof import("../types").FormState,
    ) => (e: React.ChangeEvent<any>) => void;
  };

export function Step3({
  data,
  validationErrors,
  clearValidationError,
  stepFocusRef,
  descriptionOfTab3,
  onChange,
  onBlur,
}: Props) {
  return (
    <>
      <StepHeader
        focusRef={stepFocusRef}
        ariaLabel="Steg 3: Om oss"
        description={descriptionOfTab3}
      />

      <TextInput
        label="Organisationsnummer"
        value={data.orgNumber}
        onChange={(e) => {
          onChange("orgNumber")(e);
          clearValidationError("orgNumber");
        }}
        onBlur={onBlur("orgNumber")}
        required
        hasError={validationErrors.has("orgNumber")}
        errorMessage={
          !data.orgNumber
            ? "Fältet är obligatoriskt."
            : "Fältet måste innehålla ett giltigt organisationsnummer med endast siffror och bindestreck."}
        id="orgNumber"
      />

      <TextInput
        label="Telefonnummer för publicering i Rörelseguiden"
        value={data.phone}
        onChange={onChange("phone")}
        type="tel"
      />

      <TextInput
        label="E-post"
        value={data.email}
        onChange={(e) => {
          onChange("email")(e);
          clearValidationError("email");
        }}
        onBlur={onBlur("email")}
        type="email"
        id="email"
        required
        hasError={validationErrors.has("email")}
        errorMessage={
          !data.email
            ? "Fältet är obligatoriskt."
            : "Fältet måste innehålla en giltig e-postadress."
        }
      />

      <TextInput
        label="Webbsida"
        value={data.website}
        onChange={onChange("website")}
      />

      <TextInput
        label="Facebook"
        value={data.facebook}
        onChange={onChange("facebook")}
        pattern="^\S+$"
      />

      <TextInput
        label="Instagram"
        value={data.instagram}
        onChange={onChange("instagram")}
        pattern="^\S+$"
      />

      <TextInput
        label="Tillgänglighetsdatabasen"
        value={data.tdLink}
        onChange={onChange("tdLink")}
        helpText="Finns er lokal med i Tillgänglighetsdatabasen www.t-d.se, ange länk."
      />
    </>
  );
}
